import "@/App.css";
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
const Home = lazy(() => import('@/pages/Home'));
const Services = lazy(() => import('@/pages/Services'));
const About = lazy(() => import('@/pages/About'));
const Contact = lazy(() => import('@/pages/Contact'));
const Forms = lazy(() => import('@/pages/Forms'));
const AdultQuestionnaire = lazy(() => import('@/pages/forms/AdultQuestionnaire'));
const AdultInformation = lazy(() => import('@/pages/forms/AdultInformation'));
const ChildQuestionnaire = lazy(() => import('@/pages/forms/ChildQuestionnaire'));
const ChildInformation = lazy(() => import('@/pages/forms/ChildInformation'));

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Layout>
          <Suspense fallback={<div className="min-h-[45vh] flex items-center justify-center text-slate-600" role="status">Loading page…</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/forms/adult-questionnaire" element={<AdultQuestionnaire />} />
              <Route path="/forms/adult-information" element={<AdultInformation />} />
              <Route path="/forms/child-questionnaire" element={<ChildQuestionnaire />} />
              <Route path="/forms/child-information" element={<ChildInformation />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
